export default __webpack_public_path__ + "static/media/background-plant2.2354ba0f.png";